export default __webpack_public_path__ + "static/media/Project-management1.b5d6fcd3.svg";